import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';
import { AzButtonComponent } from '../../shared/components/az-button/az-button.component';
import { ScrollActivityDirective } from '../../shared/directives/scroll-activity.directive';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [
    CommonModule,
    ToolbarComponent,
    FooterComponent,
    AzButtonComponent,
    ScrollActivityDirective,
  ],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class SupportComponent {
  protected readonly copilotChatUrl =
    'https://m365.cloud.microsoft/chat/?titleId=T_d4064dce-3c78-5707-6999-b5f3bf3f3fc2&source=embedded-builder';
  protected readonly userGuideUrl = 'https://az.box.com/s/j1mmvka0t3qwb9mvqzi91qtebxvasuh2';
  protected readonly supportEmail = 'bindingcorporaterules@astrazeneca.com';
  protected readonly helpDeskResponseTimeLabel = 'We typically respond within 48 business hours.';

  protected onStartChatting(): void {
    window.open(this.copilotChatUrl, '_blank', 'noopener');
  }

  protected onDownloadUserGuide(): void {
    window.open(this.userGuideUrl, '_blank', 'noopener');
  }
}
